(function () {
  "use strict";

  var tracked = new Set();
  var pending = [];
  var sharedObserver = null;
  var scrollBound = false;
  var pollTimer = null;

  function trackKeyFor(payload) {
    return String(payload.item_list_id || "") + "|" + window.location.pathname;
  }

  function pushViewItemList(payload) {
    if (!payload || !payload.items || !payload.items.length) return false;

    var trackKey = trackKeyFor(payload);
    if (tracked.has(trackKey)) return true;
    tracked.add(trackKey);

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ ecommerce: null });
    window.dataLayer.push({
      event: "view_item_list",
      ecommerce: {
        item_list_id: payload.item_list_id,
        item_list_name: payload.item_list_name,
        section_name: payload.section_name || payload.item_list_name,
        currency: payload.currency || "AED",
        items: payload.items
      }
    });

    // Temporary test helper — remove once agency QA is done.
    if (window.location.search.indexOf("ga4_debug=1") > -1 || window.__GA4_VIL_DEBUG) {
      console.log(
        "[GA4 view_item_list]",
        payload.item_list_name,
        "| items:",
        payload.items.length,
        payload.items
      );
    }

    return true;
  }

  function isRoughlyVisible(el) {
    if (!el || !el.getBoundingClientRect) return false;
    var rect = el.getBoundingClientRect();
    var vh = window.innerHeight || document.documentElement.clientHeight || 0;
    var vw = window.innerWidth || document.documentElement.clientWidth || 0;
    // Allow 0-size during Flickity/AOS layout — still count if the box crosses the viewport.
    return rect.bottom > 0 && rect.right > 0 && rect.top < vh && rect.left < vw;
  }

  function findObserveTarget(script) {
    var featured = script.closest(".featured-collection__container");
    if (featured) return featured;

    var shopifySection = script.closest(".shopify-section");
    if (shopifySection) return shopifySection;

    var sibling = script.nextElementSibling;
    while (sibling) {
      if (
        sibling.matches &&
        sibling.matches(".productgrid--items, .featured-collection__content")
      ) {
        return sibling;
      }
      if (sibling.querySelector) {
        var grid = sibling.querySelector(
          ".productgrid--items, .featured-collection__content"
        );
        if (grid) return grid;
      }
      sibling = sibling.nextElementSibling;
    }

    return script.parentElement || script;
  }

  function removePending(entry) {
    var idx = pending.indexOf(entry);
    if (idx > -1) pending.splice(idx, 1);
    if (sharedObserver && entry && entry.target) {
      try {
        sharedObserver.unobserve(entry.target);
      } catch (e) {}
    }
    if (!pending.length && pollTimer) {
      clearInterval(pollTimer);
      pollTimer = null;
    }
  }

  function flushEntry(entry) {
    if (!entry) return;
    if (tracked.has(trackKeyFor(entry.payload))) {
      removePending(entry);
      return;
    }
    if (pushViewItemList(entry.payload)) {
      removePending(entry);
    }
  }

  function checkPending() {
    if (!pending.length) return;
    pending.slice().forEach(function (entry) {
      if (isRoughlyVisible(entry.target)) {
        flushEntry(entry);
      }
    });
  }

  function getSharedObserver() {
    if (sharedObserver) return sharedObserver;
    if (!("IntersectionObserver" in window)) return null;

    sharedObserver = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (ioEntry) {
          // Trust IO — do not re-gate with getBoundingClientRect (Flickity/AOS can lie).
          if (!(ioEntry.isIntersecting || ioEntry.intersectionRatio > 0)) return;
          for (var i = 0; i < pending.length; i++) {
            if (pending[i].target === ioEntry.target) {
              flushEntry(pending[i]);
              break;
            }
          }
        });
      },
      { threshold: 0, rootMargin: "50px 0px 50px 0px" }
    );
    return sharedObserver;
  }

  function bindScrollFallback() {
    if (scrollBound) return;
    scrollBound = true;
    window.addEventListener("scroll", checkPending, { passive: true });
    window.addEventListener("resize", checkPending);
    document.addEventListener("touchmove", checkPending, { passive: true });

    // Poll briefly while Flickity/AOS finish layout.
    var ticks = 0;
    pollTimer = setInterval(function () {
      checkPending();
      ticks += 1;
      if (ticks > 40 || !pending.length) {
        clearInterval(pollTimer);
        pollTimer = null;
      }
    }, 250);
  }

  function observeWhenVisible(target, payload) {
    if (!target) {
      pushViewItemList(payload);
      return;
    }

    var entry = { target: target, payload: payload };
    pending.push(entry);

    if (isRoughlyVisible(target)) {
      flushEntry(entry);
    }

    // Always keep watching remaining lists (do not early-return).
    if (tracked.has(trackKeyFor(payload))) return;

    var observer = getSharedObserver();
    if (observer) {
      observer.observe(target);
    }

    bindScrollFallback();
  }

  function init(root) {
    var scope = root && root.querySelectorAll ? root : document;
    var nodes = scope.querySelectorAll("[data-ga-view-item-list]");

    nodes.forEach(function (script) {
      if (script.getAttribute("data-ga-vil-bound") === "1") return;
      script.setAttribute("data-ga-vil-bound", "1");

      var payload;
      try {
        payload = JSON.parse(script.textContent);
      } catch (e) {
        return;
      }

      if (!payload.items || !payload.items.length) return;

      observeWhenVisible(findObserveTarget(script), payload);
    });

    checkPending();
    bindScrollFallback();
  }

  // Helpful for console debugging after upload:
  // window.__ga4VilStatus()
  // window.__ga4VilCurrent()  — event for the carousel currently in view
  window.__ga4VilStatus = function () {
    return {
      tracked: Array.from(tracked),
      pending: pending.map(function (e) {
        return e.payload && e.payload.item_list_name;
      }),
      events: (window.dataLayer || []).filter(function (e) {
        return e && e.event === "view_item_list";
      }).length
    };
  };

  window.__ga4VilCurrent = function () {
    var vh = window.innerHeight || document.documentElement.clientHeight || 0;
    var sections = document.querySelectorAll(
      ".featured-collection__container[data-featured-collection], .featured-collection__container"
    );
    var best = null;
    var bestScore = -1;

    sections.forEach(function (section) {
      var rect = section.getBoundingClientRect();
      var visibleTop = Math.max(rect.top, 0);
      var visibleBottom = Math.min(rect.bottom, vh);
      var visible = Math.max(0, visibleBottom - visibleTop);
      if (visible <= 0) return;

      // Prefer the section centered in the viewport.
      var center = (rect.top + rect.bottom) / 2;
      var dist = Math.abs(center - vh / 2);
      var score = visible * 10 - dist;
      if (score > bestScore) {
        bestScore = score;
        best = section;
      }
    });

    if (!best) {
      console.log("[GA4] No product carousel currently in view");
      return null;
    }

    var script = best.querySelector("[data-ga-view-item-list]");
    var listId = null;
    var listName = null;
    if (script) {
      try {
        var payload = JSON.parse(script.textContent);
        listId = payload.item_list_id;
        listName = payload.item_list_name;
      } catch (e) {}
    }

    var match = (window.dataLayer || [])
      .filter(function (e) {
        return e && e.event === "view_item_list" && e.ecommerce;
      })
      .reverse()
      .find(function (e) {
        if (listId && e.ecommerce.item_list_id === listId) return true;
        if (listName && e.ecommerce.item_list_name === listName) return true;
        return false;
      });

    if (!match) {
      console.log("[GA4] Carousel in view but event not fired yet:", listName || best);
      return null;
    }

    console.log(
      "[GA4 view_item_list — current]",
      match.ecommerce.item_list_name,
      "| items:",
      match.ecommerce.items.length,
      match
    );
    return match;
  };

  // While debugging (?ga4_debug=1 or window.__GA4_VIL_DEBUG = true),
  // log the current carousel shortly after you stop scrolling.
  var stopScrollTimer = null;
  function bindStopScrollDebug() {
    if (!(window.location.search.indexOf("ga4_debug=1") > -1 || window.__GA4_VIL_DEBUG)) {
      return;
    }
    window.addEventListener(
      "scroll",
      function () {
        clearTimeout(stopScrollTimer);
        stopScrollTimer = setTimeout(function () {
          window.__ga4VilCurrent();
        }, 400);
      },
      { passive: true }
    );
  }
  bindStopScrollDebug();

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () {
      init(document);
    });
  } else {
    init(document);
  }

  document.addEventListener("shopify:section:load", function (event) {
    init(event.target);
  });
})();
